import { act } from "react";
import { submitSale } from '../../services/inventoryApi.js';
import { fetchTables } from '../../services/tableApi.js';

export const createSalesSlice = (set, get) => ({
  activeTab: 'Walk-in',
  category: 'All',
  selectedTable: '',
  selectedPending: '',
  receiptItems: [],
  discount: 0,
  receivedCash: '',
  nextTableId: 4,
  branchTables: [],
  previewOpen: false,
  previewMode: 'Receipt',
  tablesLoaded: false,
  editingOrder: null, // Track the order being edited

  tablePaymentInfo: {
    amount: 0,
    paymentType: 'Cash',
    discount: 0
  },

  updatePaymentInfo: (info) => set((state) => ({
    tablePaymentInfo: {
      ...state.tablePaymentInfo,
      ...info
    }
  })),

  setActiveTab: (tab) => set({ activeTab: tab }),
  setCategory: (category) => set({ category }),
  setSelecteTable: (selectedTable) => set({ selectedTable }),
  setSelectedPending: (selectedPending) => set({ selectedPending }),
  setDiscount: (discount) => set({ discount }),
  setReceivedCash: (receivedCash) => set({ receivedCash }),

  loadTables: async () => {
    try {
      const response = await fetchTables();
      const apiTables = response.tables || [];
      set({ branchTables: apiTables, tablesLoaded: true });
    } catch (error) {
      console.error('Error loading tables:', error);
      set({ tablesLoaded: true });
    }
  },


  createTable: (tableName) =>
    set((state) => {
      const trimmedName = (tableName || '').trim();
      const label = trimmedName || `Table ${state.nextTableId}`;
      const value = label.replace(/\s+/g, '');
      if (state.branchTables.some((table) => {
        const key = table.value || table.id || table.tableId || '';
        return key.toLowerCase() === value.toLowerCase();
      })) {
        return {};
      }
      return {
        branchTables: [...state.branchTables, { id: value, value, name: label, tableId: value, tableName: label, items: [], is_active: false }],
        nextTableId: state.nextTableId + 1
      };
    }),

  activateTable: (value) =>
    set((state) => ({
      branchTables: state.branchTables.map((table) => {
        const key = table.value || table.id || table.tableId || '';
        return key === value ? { ...table, is_active: true } : table;
      })
    })),

  deactivateTable: (value) =>
    set((state) => ({
      branchTables: state.branchTables.map((table) => {
        const key = table.value || table.id || table.tableId || '';
        return key === value ? { ...table, is_active: false } : table;
      })
    })),

  setTables: (branchTables) => set({ branchTables }),

  removeTable: (value) =>
    set((state) => ({
      branchTables: state.branchTables.filter((table) => {
        const key = table.value || table.id || table.tableId || '';
        return key !== value;
      })
    })),

  cancelTableOrder: (value) =>
    set((state) => ({
      branchTables: state.branchTables.map((table) => {
        const key = table.value || table.id || table.tableId || '';
        return key === value ? { ...table, items: [], is_active: false } : table;
      })
    })),

  addReceiptItemsToTable: (tableId, newItems) =>
    set((state) => ({
      branchTables: state.branchTables.map((table) => {
        if (table.id !== Number.parseInt(tableId)) return table;
        
        const updatedItems = [...(table.items || [])];
        newItems.forEach((newItem) => {
          const index = updatedItems.findIndex(
            (item) => item.id === newItem.id
          );

          if (index !== -1) {
            // ✅ Merge (increase quantity)
            updatedItems[index] = {
              ...updatedItems[index],
              quantity:
                updatedItems[index].quantity + (newItem.quantity || 1),
            };
          } else {
            // ✅ Add new item
            updatedItems.push({
              ...newItem,
              quantity: newItem.quantity || 1,
            });
          }
        });

        return {
          ...table,
          items: updatedItems,
          is_active: true,
        };
      }),
    })),

  addReceiptItem: (product) =>
    set((state) => {
      const existing = state.receiptItems.find((item) => item.id === product.id);
      if (existing) {
        return {
          receiptItems: state.receiptItems.map((item) =>
            item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
          )
        };
      }
      return { receiptItems: [...state.receiptItems, { ...product, quantity: 1 }] };
    }),

  updateReceiptQuantity: (id, quantity) =>
    set((state) => ({
      receiptItems: state.receiptItems.map((item) =>
        item.id === id ? { ...item, quantity } : item
      )
    })),

  removeReceiptItem: (id) =>
    set((state) => ({
      receiptItems: state.receiptItems.filter((item) => item.id !== id)
    })),

  clearReceipt: () =>
    set({
      receiptItems: [],
      selectedTable: '',
      selectedPending: '',
      discount: 0,
      receivedCash: ''
    }),

  openPreview: (mode) =>
    set({
      previewMode: mode,
      previewOpen: true
    }),

  closePreview: () =>
    set({
      previewOpen: false
    }),

  setPreviewMode: (mode) =>
    set({
      previewMode: mode
    }),

  setEditingOrder: (order) =>
    set({
      editingOrder: order
    }),

  clearEditingOrder: () =>
    set({
      editingOrder: null
    }),

  loadOrderForEditing: (order) =>
    set((state) => {
      if (!order || !order.items) return {};
      
      // Transform order items to receipt items
      const items = order.items.map((item) => ({
        id: item.product_id || item.id,
        name: item.product_name || item.name,
        price: item.unit_price || item.price,
        quantity: item.quantity,
        categoryId: item.category_id
      }));

      return {
        editingOrder: order,
        receiptItems: items,
        discount: order.discount || 0,
        selectedTable: order.table_name || '',
        selectedPending: order.order_type === 'waiter' ? order.waiter_id : ''
      };
    }),

});
